import { id, root } from './clips';
import { recent } from './recent';

export const clips = {
  ...root,
  recent,
  id,
};
